export default __webpack_public_path__ + "static/media/HowItWorks-04.3f4f9937.jpg";